<template>
  <head>
    <title>
      {{ $t("Team") }}
    </title>
  </head>
  <div class="team-view">
    <AdminSidebar>
      <TableComponent
        :titles="titles"
        :data="data"
        :title="title"
        :pageUrl="pageUrl"
        deleteApi="api/delete_team"
        EditUrl="/update-team"
      />
    </AdminSidebar>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import TableComponent from "@/components/AdminDashboard/TableComponent.vue";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";

export default {
  name: "team-view",
  data() {
    return {
      data: {},
      ErrorMessage: "",
      titles: [
        "id",
        "name_ar",
        "name_en",
        "position_ar",
        "position_en",
        "delete",
        "update",
        "show",
      ],
      title: "Team",
      pageUrl: "AddTeam",
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_team")
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
      store.state.loading_state = 0;
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    TableComponent,
    AdminSidebar,
  },
};
</script>
